import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.Step = React.createClass({
  getInitialState: function() {
    return {
      phoneErrorMessage: ''
    }
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps.currentStep !== this.props.currentStep && this.state.phoneErrorMessage) {
      this.setState({ phoneErrorMessage: '' })
    }
  },

  handlePhoneErrorChange: function(message) {
    this.setState({ phoneErrorMessage: message || '' })
  },

  onStepProgression: function() {
    if(this.props.currentStep.onSubmit) {
      if (this.recordDisplayName()) {
        Job.Actions.updateProgressWidth(this.props.currentStep.displayName)
      }

      this.props.currentStep.onSubmit(this.props.onStepProgression, this.props.onRequest, this.props.onRequestCompletion)
    }
  },

  recordDisplayName() {
    let includedInInitialSteps = JobWizard.StepSequence.stepsWithProgress().includes(this.props.currentStep.displayName)
    let includedInNextSteps = JobWizard.StepSequence.combinedStepsWithProgress().includes(this.props.currentStep.displayName)

    return (includedInInitialSteps || includedInNextSteps)
  },

  onStepRetreat: function() {
    this.props.currentStep.onLeftNavButtonClick ? this.props.currentStep.onLeftNavButtonClick(this.props.onStepProgression) : this.props.onStepRetreat()
  },

  onModalExit: function() {
    var $jobModal = $('#job-modal')

    if (Job.Data.id !== null) {
      $jobModal.find('.close-modal-warning').velocity('slideUp').end()
                .find('.close').rmHidden()
      JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.UpdateJob, 'exit')
      return
    }

    Job.PostingProgressActions.updateTracking({ exitType: 'modal_posting_blocked' })
    Job.PostingProgressActions.createPostingProgress()
    Job.Actions.resetData()
    this.setState({currentStep: JobWizard.Steps[0]})
    $jobModal.modal('hide')
    $jobModal.find('.modal-stay').trigger('click') // hide this warning
    JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Steps[0])
  },

  onSecondaryNavButtonClick: function() {
    this.props.currentStep.onSecondaryNavButtonClick ? this.props.currentStep.onSecondaryNavButtonClick() : null
  },

  componentWillEnter(callback) {
    const el = findDOMNode(this);
    TweenMax.fromTo(el, 0.3, {y: 100, opacity: 0}, {y: 0, opacity: 1, onComplete: callback});
  },

  navButtonLayout: function() {
    var buttonDefault = window.mobilecheck() === true ? 'upAndDownButton' : 'default'

    return this.props.currentStep.buttonLayout ? this.props.currentStep.buttonLayout() : buttonDefault
  },

  handleClick: function(e) {
    let text = $(e.target).parents('.form-group').last().find('h3').text()
    Job.PostingProgressActions.updateTracking({lastQuestion: text})
  },

  renderOmniAuthLogin: function() {
    return(
      <div>
        { this.props.currentStep === JobWizard.EmailAddress &&
          <JobWizard.OmniAuthLogin handleSubmit={this.props.currentStep.onSubmit} />
        }
      </div>
    )
  },

  render: function() {
    const ComponentClass = this.props.currentStep.component;

    return (
      <div className="job-modal-step"> {/* extra div below needed by react */}
        <JobWizard.Header/>
        <div className="modal-body job-form-body pb0 pt0 radius-16-bottom" onClick={this.handleClick} onInput={this.handleClick}>
          <ComponentClass
            onStepProgression={this.onStepProgression}
            onRequest={this.props.onRequest}
            onRequestCompletion={this.props.onRequestCompletion}
            onPhoneErrorChange={this.handlePhoneErrorChange}
          />
        </div>
        <div className="modal-footer pt0">
          <JobWizard.NavigationButtons
            navButtonLayout={this.navButtonLayout()}
            buttons={this.props.currentStep.navigation} //overrides for button text etc
            onStepProgression={this.onStepProgression}
            onStepRetreat={this.onStepRetreat}
            onSecondaryNavButtonClick={this.onSecondaryNavButtonClick}
            onModalExit={this.onModalExit}
          />
        </div>
        { this.state.phoneErrorMessage &&
          <div className="row pb24">
            <div className="col-xs-12 text-center text-red mt24 mb0">
              {this.state.phoneErrorMessage}
            </div>
          </div>
        }
        { this.renderOmniAuthLogin() }
      </div>
    )
  }
})
